export const splitProductIds = (str) => str?.split(';');
